import {
	ShowMore,
	type ShowMoreRef,
	type ShowMoreToggleLinesFn,
} from "@re-dev/react-truncate";
import type { Company, ScreenerData } from "epsm-api-types/models";
import { useRef } from "react";
import { Button } from "@/components/ui/button";
import { componentClassNames } from "../../../config";
import { QuoteTitle } from "../QuoteTitle";

export const Description = ({
	screenerData,
	companyData,
}: {
	screenerData: ScreenerData | null;
	companyData: Company | null;
}) => {
	const ref = useRef<ShowMoreRef>(null);

	const toggleLines: ShowMoreToggleLinesFn = (e) => ref.current?.toggleLines(e);

	const noData =
		companyData?.short_description == null &&
		screenerData?.sector_spdr_code == null &&
		screenerData?.inc_country == null &&
		screenerData?.stock_exchange == null;

	return (
		<div className={componentClassNames}>
			<QuoteTitle title="Description" className="text-center" />

			{noData ? (
				<p>No data available.</p>
			) : (
				<ShowMore
					ref={ref}
					lines={2}
					more={
						<span>
							{"... "}
							<Button
								variant="dropdown"
								onClick={toggleLines}
								className="p-0 m-0 h-5"
								data-testid="more-button"
							>
								More...
							</Button>
						</span>
					}
					less={
						<p className="text-end">
							<Button
								variant="dropdown"
								onClick={toggleLines}
								className="p-0 m-0 h-5"
							>
								Less
							</Button>
						</p>
					}
					className="text-light-gray"
					data-testid="show-more"
				>
					<div className="flex flex-col gap-5">
						{companyData?.short_description ?? ""}

						<div className="text-light-gray">
							{screenerData?.sector_spdr_code != null && (
								<p>Associated Sector: {screenerData?.sector_spdr_code}</p>
							)}
							{screenerData?.inc_country != null && (
								<p>Ctry: {screenerData?.inc_country}</p>
							)}
							{screenerData?.stock_exchange != null && (
								<p>Exch: {screenerData?.stock_exchange}</p>
							)}
						</div>
					</div>
				</ShowMore>
			)}
		</div>
	);
};
